export default __webpack_public_path__ + "static/media/user-line.8b056314.svg";